import React from 'react';
import { Line } from 'react-chartjs-2';
import { formatDate } from "../../Common/Utils/dateUtils";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const UserActivityChart = ({ users_activity }) => {
  const activityData = users_activity || [];

  const borderColors = ["#856E45"];
  const data = {
    labels: activityData.map(item => formatDate(item.date, "")), // Ensure correct labels
    datasets: [
      {
        label: 'Invoices created',
        data: activityData.map(item => item.invoice_count), // Use invoice_count instead of count
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: borderColors[0], // Since only one color is needed
        borderWidth: 2,
        tension: 0.4,
      },
    ],
  };

  const options = {
    scales: {
      x: {
        ticks: { color: 'black' },
      },
      y: {
        ticks: { color: 'black', stepSize: 1 },
      },
    },
  };

  return (
    <div className='user-activity-graph' style={{ maxWidth: '100%',     margin: 'auto' }}>
      {activityData.length > 0 ? (
        <Line data={data} options={options} />
      ) : (
        <p>No user activity data available</p>
      )}
    </div>
  );
};

export default UserActivityChart;
